import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';

import BaseTable, { 
    TableStore,
    connect,
    useStore, 
    useResize, 
    useIndex, 
    useCheckbox, 
    useSort, 
    useExpandRow,
    useTreeTable,
    useFilter,
    usePagination,
    useErrorTips,
    useRowClick,
    useLocation,
    useContextMenu,
    useCellSelect,
    useHotKey,
    useDOM,
    useEditTable,
    useCache,
    useStyle,
} from "@platform/table-core";

// import { WithKeyboardChange } from '@platform/base';
import { getAutoWrap } from '../../libs/useContextMenu';
import { 
    handleBeforeEvent, 
    handleAfterEvent, 
    splitPks, 
    setAutoWrap, 
    isEmptyValue, 
    getRowHeight,
} from '../utils';
import { getMultiLang, ViewModel, getGlobalStorage } from '@platform/api';
import { ROW_STATUS } from '../../utils';
import { getCheckedExtendMethod } from '../../../../FastExtend/utils';

// const { EditTableWithKeyboardChange } = WithKeyboardChange;

let hookExtensions = [
    // EditTableWithKeyboardChange,
    connect,
    useHotKey, 
    useStore, 
    useResize,
    useIndex,
    useCheckbox,
    useExpandRow,
    useRowClick,
    useTreeTable,
    useSort,
    useCellSelect,
    useDOM,
    useEditTable,
    usePagination,
    useCache,
    useFilter,
    useLocation,
    useContextMenu,
    useStyle,
    // useCopy,
    useErrorTips,
];

const ComposedTable = hookExtensions.reduceRight((Table, HOC) => HOC(Table), BaseTable);

class EditTable extends Component {
    componentDidMount() {
        this.props.store.setRef(this);

        let { store } = this.props;

        getMultiLang({
            moduleId: "page_table",
            callback: json => {
                store.setLocale(json);
            }, 
        });

        this.useCache();
    }
    
    render () {

        let {
                high_selectable,
                onCloseModel, // pass 侧拉点击关闭按钮时回调
                tableModelConfirm, // pass 侧拉点击确定按钮时回调
                selectedChange, // p
                onSelectedAll, // p
                setCellClass, // p
                onRowClick, //p
                onRowDoubleClick, //p
                onSelected, //p
                inputChange, // p
                rowClassList, // p
                showPagination, //p
                handlePageInfoChange, //p
                showCheck,
                showIndex,
                alloweFilter: enableFilter = true, // p
                multipleRowCell = false,
                onBatchSelected, // p
                onBatchChange,
                onBeforeEvent, // p
                onAfterEvent, // p
                hideRightMenu = false,
                extendRightMenu,
                extendRightMenuPlacement,
                handleFilterCallBack,
                handleResetCallBack,
                sort,
                isAddRow, //p
                addRowDefaultValue = {}, // p
                addRowCallback, // p
                noColSetClass,
                colSetCallback,
                showTotal,
                rightMenuClick,
                cancelCustomRightMenu = false, // true时，不显示右键菜单里的列表设置
                showWidthAndHeightConfig = true,
                height,
                adaptionHeight = true,
                fieldid,
                footer,
                id,
                store,
                crossPageSelect,
                pkname,
                pageScope,
                allowTotalRows,
                noTotalRows,
                noTotalCol,
                onTableCellClick,
                bodyStyle,
                isSort = true, // 开启排序
                addBlankCol,
                hiddenLeftItem,
                columnWidthConfig = true,
                fixFooter,
                scrollContainer,
                // addAffixScroll: fixFooter,
            } = this.props,
            config = store.getConfig(),
            useVirtual = true;

        /**
         * cancelCustomRightMenu=false / columnWidthConfig = true / extendRightMenu有值 / foldingRowChange有值时，需要有右键菜单
         * cancelCustomRightMenu=false时显示列设置图标
         */
        if(hideRightMenu){
            cancelCustomRightMenu = true;
        }
    
        //初始化
        if(config.hasOwnProperty('multipleRowCell')){
            setAutoWrap(store, id, config.multipleRowCell);
        }

        height = bodyStyle?.height ?? height;

        let ncc_automated = getGlobalStorage('localStorage', '_ncc_automated_');
        if (ncc_automated == '1') {
            // 自动化测试开关打开
            useVirtual = false;
        }

        return <ComposedTable 
            id={id} 
            key={id} 
            store={store} 
            pageScope={pageScope}
            allowTotalRows={allowTotalRows}
            noTotalRows={noTotalRows}
            noTotalCol={noTotalCol}
            fixFooter={fixFooter}
            scrollContainer={scrollContainer}
            autoRowHeight={getAutoWrap(store, id)}
            bodyStyle={{ 
                height: height || 300,
                minHeight: 60,
            }}
            addBlankCol={addBlankCol}
            flex={adaptionHeight}
            rowHeight={getRowHeight()}
            className="edit-table"
            defaultRenderStatus='edit'
            pkname={pkname}
            crossPageSelect={crossPageSelect}
            renderItems={pageScope.state.renderItem?.table?.[id] || {}}
            rowKey={row => row.key}
            indexConfig={{ enable: showIndex }}
            virtualConfig={{ x: useVirtual }}
            checkboxConfig={{ 
                enable: showCheck,
                more: crossPageSelect && pkname && store.getStatus() !== 'edit',            
                onCheck: (rowKey, { isChecked, checkedKeys, lastCheckedKeys }) => {
                    let visibleKeysLength = store.getVisibleRowKeys()?.length || 0;
                    if(rowKey){ //单行改变
                        let row = store.getRowData(rowKey);
                        // if (isChecked ) {
                        store.setClickedRow(row.key);
                        // } else {
                        //     store.setClickedRow('');
                        // }
                        onSelected?.(
                            { ...pageScope.props, ...pageScope.output }, 
                            id, 
                            row, 
                            row.dataIndex, 
                            isChecked,
                            //TODO isUnique
                        );
                    } else {
                        onSelectedAll?.(
                            { ...pageScope.props, ...pageScope.output }, 
                            id,
                            !!checkedKeys?.size,
                            visibleKeysLength,
                        );
                    }

                    selectedChange?.({ ...pageScope.props, ...pageScope.output }, id, checkedKeys?.size || 0, lastCheckedKeys?.size || 0);
                },
            }}
            paginationConfig={{ 
                enable: showPagination && store.getStatus() !== 'edit',
                onChange: ({ pageIndex, pageSize }) => {
                    let allPks = store.getAllRowsInfo()?.allpks;
                    let pks = splitPks(allPks, pageIndex, pageSize);
                    handlePageInfoChange?.({ ...pageScope.output, ...pageScope.props }, config, pks, store.getPaginationInfo()?.total, { tableId: id });
                },
            }}
            filterConfig={{ 
                enable: enableFilter,
                title: store.getMeta()?.[id]?.name || '',
                onFilter: handleFilterCallBack,
                onReset: handleResetCallBack,
            }}
            sortConfig={{ 
                enable: isSort,
                onSort: orderMap => {
                    let sortInfo = Object.keys(orderMap).map((colKey, index) => {
                        return {
                            order: orderMap[colKey] === 1 ? "ascend" : "descend",
                            field: undefined,
                            orderNum: index,
                        };
                    });
                    sort?.sortFun?.(sortInfo, store.getVisibleRows());
                },
            }}
            locationConfig={{ enable: true }}
            cellSelectConfig={{ 
                enable: high_selectable?.enable ?? true,
                batchSelectEnable: !!onBatchChange,
                beforeSelect: high_selectable?.beforeClearData,
                onSelect: (selectedCell, { startCell, endCell, batchSelect }) => {
                    console.log('框选', selectedCell);
                
                    if (!startCell || !endCell || batchSelect) {
                        return;
                    }

                    // if (!selectedCell.size) {
                    //     // 清空
                    //     high_selectable?.beforeClearData?.();
                    // }

                    if (onBatchSelected) {
                        /**
                         * 传了这个参数，才勾选前面的行。以前的逻辑是这样的
                         * 如果选中的是单行，走onRowClick逻辑
                         * 否则这里设置选中
                         */
                        // startCell.row.key !== endCell.row.key && store.setCheckedKeys(new Set([...selectedCell.keys()]));
                        // 单行onRowClick走不到这里，cellSelect那里已经阻断了
                        store.setCheckedKeys(new Set([...selectedCell.keys()]));
                        onBatchSelected(
                            {
                                ...pageScope.props,
                                ...pageScope.output,
                            }, 
                            id, 
                            [...selectedCell].map(([rowKey]) => store.getRowData(rowKey)),
                        );
                    }
                },
                onChange: (selectedRows, { column, row, oldValues, texts }) => {
                    console.log('批改', selectedRows, column, row);

                    let colKey = column.key;

                    onBatchChange?.({
                        allData: store.getRows(),
                        areaCode: id,
                        changedrows: selectedRows.map((row, index) => {
                            return {
                                newvalue: { value: texts[index] },
                                oldvalue: oldValues[index],
                                rowid: row.key,
                            };
                        }),
                        column,
                        currentIndex: selectedRows[0].dataIndex,
                        newValue: selectedRows.map((row, index) => {
                            row = {
                                ...row,
                                values: {
                                    ...row.values,
                                    [colKey]: { value: texts[index] },
                                },
                            };
                            return row;
                        }),
                        pasteData: texts.map(e => typeof e === 'string' ? e.trim() : e),
                    });

                    // selectedRows.forEach(row => {
                    //     store.setCellValue(row.key, column.key, { value: row.values[colKey] });
                    // });
                },
                exclude: high_selectable?.disabledColumn ?? [],
            }}
            cellProps={(rowInfo, colInfo) => {
                let props = {};
                if (typeof onTableCellClick === 'function') {
                    props.onClick = e => {
                        onTableCellClick(rowInfo.row, rowInfo.rowIndex, colInfo.col.key, colInfo.col, e);
                    }; 
                }
                if (typeof setCellClass === 'function') {
                    props.className = setCellClass(rowInfo.rowIndex, rowInfo.row, colInfo.col.key);
                }
                return props;
            }}
            rowProps={row => {
                let className = '',
                    dataIndex = row.dataIndex;

                if (Array.isArray(rowClassList)) {
                    className = rowClassList.filter(({ index }) => {
                        if (!Array.isArray(index)) {
                            index = [index];
                        }
                        return index.includes(dataIndex);
                    }).map(e => e.className).join(' ');
                } else if (typeof rowClassList === 'function') {
                    className = rowClassList(row, dataIndex);
                } else {
                    className = rowClassList;
                }

                return {
                    className,
                    onClick:  e => onRowClick?.({ ...pageScope.props, ...pageScope.output }, id, row, store.getRowData(row.key).dataIndex, e),
                    onDoubleClick: onRowDoubleClick && (e => onRowDoubleClick?.(row, store.getRowData(row.key).dataIndex, { ...pageScope.props, ...pageScope.output }, e)), 
                };
            }}
            onBeforeEvent={({ value, event, colKey, rowKey }) => {
                console.log('EditTable表体编辑前事件', value, event, colKey, rowKey);

                let row = store.getRowData(rowKey),
                    column = store.getColumnProps(colKey);
                    
                store.setCache('oldBatchData', { colKey, dataIndex: row.dataIndex });
                store.setClickedRow(rowKey);

                return handleBeforeEvent.call(pageScope, {
                    row, 
                    column,
                    value,
                    moduleId: id,
                    callback: () => {
                        return onBeforeEvent?.(
                            { ...pageScope.props, ...pageScope.output },
                            id,
                            column,
                            row.dataIndex,
                            value,
                            row,
                        );
                    },
                    type: 'onEditTableBeforeEvent',
                });
            }}
            onValueChange={(rowKey, { attrcode, value }) => {
            // 编辑中change回调 参考原代码
                let column = store.getColumnProps(attrcode),
                    row = store.getRowData(rowKey);
                // 为郭祉琪加的针对input类型时,这两个字段的特殊校验,换算率
                if (column.itemtype === 'input' && ['vchangerate', 'vqtunitrate'].includes(column.attrcode)) {
                // eslint-disable-next-line no-useless-escape
                    let reg = /^[0-9\/\.]+$/;
                    if (value && !reg.test(value)) { //只能输入数字和/
                        return;
                    }
                }
                //胡杰李忠博加
                if (typeof inputChange === 'function') {
                // 转换一下index
                    inputChange({ index: row.dataIndex, item: column, valueChange: value.value });
                }

                row.status === ROW_STATUS.ORIGIN && (row.status = ROW_STATUS.EDIT);
                store.setRowData(row);
            }}
            onAfterEvent={({ value, oldValue, componentValue, event, colKey, rowKey }) => {
                console.log('EditTable表体编辑后事件', value, oldValue, componentValue, event, colKey, rowKey);
                    
                let row = store.getRowData(rowKey),
                    column = store.getColumnProps(colKey),
                    visibleRows = store.getVisibleRows();

                // Item统一处理trim
                // typeof value?.value === 'string' && (value.value = value.value.trim());
                
                if (column.itemtype === "residtxt") {
                    // 多语文本value格式不一样，要特殊处理一下
                    [...Object.entries(value), [colKey, value[colKey]]].forEach(([subCode, subValue]) => {
                        // 同步单来源的值
                        store.setCellValue(rowKey, subCode, { value: subValue });
                    });
                } else {
                    store.setCellValue(rowKey, colKey, { value });
                }

                // 自动增行的处理 是最后一行 & 编辑态 & 当前单元格不为空 & 多语字段的值会进一步判断 这里先判断其他条件 
                if(isAddRow && (value?.value || column.itemtype === "residtxt") && row.viewIndex === visibleRows.length - 1 && store.getStatus() === 'edit'){
                    let validateValue = value.value;
                    let switchBrowser = column.itemtype === 'switch_browse' && column.disabled; // 是开关，且不可编辑

                    // 特殊类型的值获取 TODO
                    if(column.itemtype === 'residtxt'){
                        validateValue = value;
                    } else if(column.itemtype === 'refer') {
                        validateValue = componentValue;
                    }
                
                    if(!switchBrowser && !isEmptyValue(validateValue, column.itemtype)){
                        if(addRowDefaultValue instanceof Promise){
                            addRowDefaultValue.then(rowValues => {
                                store.addRow(visibleRows.length, { values: rowValues }, { autoFocus: false, rowKey: pkname });

                                visibleRows = store.getVisibleRows();
                                addRowCallback?.(store.getVisibleRows()[visibleRows.length - 1]);      
                            });
                        } else {
                            addRowDefaultValue = typeof addRowDefaultValue === 'function' ? (addRowDefaultValue() ?? {}) : JSON.parse(JSON.stringify(addRowDefaultValue));
                            store.addRow(visibleRows.length, { values: addRowDefaultValue }, { autoFocus: false, rowKey: pkname });

                            visibleRows = store.getVisibleRows();
                            addRowCallback?.(store.getVisibleRows()[visibleRows.length - 1]); 
                        }
                    }
                }

                // 触发业务编辑后
                handleAfterEvent.call(pageScope, {
                    row: store.getRowData(rowKey), 
                    column: store.getColumnProps(colKey),
                    value,
                    oldValue,
                    componentValue,
                    moduleId: id,
                    callback: ({ changedRows }) => {
                        // handleAfterEvent里更新了数据，这里要同步
                        row = store.getRowData(row.key);
                        return onAfterEvent?.(
                            {
                                ...pageScope.props,
                                ...pageScope.output,
                            },
                            id,
                            colKey,
                            // 特殊类型值的返回
                            column.itemtype === 'refer' || column.itemtype === 'residtxt' ? componentValue : value.value,
                            changedRows,
                            row.dataIndex,
                            row,
                            '', // isTriggerModal
                            '', // triggerType
                            event,
                        );
                    },
                    type: 'onEditTableAfterEvent',
                    store,
                });
            }}
            totalConfig={{ enable: showTotal }}
            contextMenuConfig={{ 
                enable: !hideRightMenu && (high_selectable?.enable ?? true) && (high_selectable?.selectCell ?? true),
                extendRightMenu,
                extendRightMenuPlacement,
                rightMenuClick,
                cancelCustomRightMenu,
                showWidthAndHeightConfig,
                hiddenLeftItem,
                columnWidthConfig,
                disableArea: (rowKey, colKey) => {
                    if(!noColSetClass) return false;
                    let cellClass = store.getCellProps(rowKey, colKey, 'className');
                    return cellClass?.includes(noColSetClass);
                },
                onColSetting: () => {
                colSetCallback?.();
                },
                onClick: () => {
                    pageScope.forceUpdate();
                },
            }}
            modalConfig={{ 
                onClose: record => onCloseModel?.call(pageScope, { ...pageScope.props, ...pageScope.output }, id, record),
                onSure: record => tableModelConfirm?.call(pageScope, { ...pageScope.props, ...pageScope.output }, id, record),
            }}
            fieldid={fieldid}
            footer={footer} />;
    }

    componentDidUpdate() {
        this.useCache();

        // 客开的旧版本钩子兼容,没有客开时不会执行客开方法
        let { store, pageScope } = this.props;
        let data = store?.getRows() || [];
        getCheckedExtendMethod(pageScope, 'updateEditTable')({ pageScope, data, props: this.props, useOn: 'create' });
    }

    componentWillUnmount() {
        let { dataSource, store, pkname } = this.props;
        
        if (dataSource) {
            let pageInfo = store.getPaginationInfo(),
                rows = store.getRows(),
                { allpks } = store.getAllRowsInfo(),
                filterInfo = store.getFilterInfo(),
                checkedInfo = store.getCheckedInfo(),
                lastClickedRow = store.getClickedRow(),
                sortInfo = store.getSortInfo(),
                visibleRows = store.getVisibleRows(),
                currentpks = visibleRows.map(row => row.values[pkname]?.value).filter(e => e),
                { pageIndex, pageSize } = pageInfo;
    
            allpks = allpks ? [...allpks] : [];

            let cacheAllPks = [...allpks];
            allpks.splice(Number(pageIndex) * Number(pageSize), pageSize, ...currentpks);

            let data = {
                simpleTable:{
                    rows: rows,
                    currentpks, // 当页的pk
                    allpks,
                    cacheAllPks,
                    pageInfo,
                    scrollTop: findDOMNode(this).querySelector('.vertical-scroll-bar').scrollTop,
                    checkedInfo,
                    filterInfo,
                    sortInfo,
                    pkname,
                    lastClickedRow,
                },
            };
        
            ViewModel.setData(dataSource, data);
        }

        this.props.store.removeRef(this);
    }

    useCache = () => {
        let { dataSource, store } = this.props,
            columns = store.getColumns(),
            { componentInitFinished } = store.getConfig() || {};

        if (dataSource && !this.cached && columns.length) {
            this.cached = true;

            let cache = ViewModel.getData(dataSource)?.simpleTable;
            
            if (!cache) return;

            if (cache.pageInfo) {
                store.setPaginationInfo(cache.pageInfo);
            }

            if (cache.rows) {
                store.setRows({ rows: cache.rows });
            }

            if (cache.cacheAllPks) {
                store.setAllRowsInfo({ allpks: cache.cacheAllPks });
            }

            if (cache.scrollTop && cache.rows.length) {
                this.scroll(cache.scrollTop);
            }

            if (cache.lastClickedRow) {
                store.setClickedRow(cache.lastClickedRow);
            }

            // if (cache.currentpks) {

            // }

            if(cache.checkedInfo) {
                store.setCheckedInfo(cache.checkedInfo);
            }

            if(cache.filterInfo){
                store.setFilterInfo(cache.filterInfo);
            }

            if(cache.sortInfo){
                store.setSortInfo(cache.sortInfo);
            }

            componentInitFinished?.();
        }
    }

    scroll = scrollTop => {
        requestAnimationFrame(() => {
            if (findDOMNode(this).querySelectorAll('.table-next-body tr:not(.empty-table)').length) {
                findDOMNode(this).querySelector('.vertical-scroll-bar').scrollTop = scrollTop;
            } else {
                scroll(scrollTop);
            }
        });
    }
}

EditTable.displayName = 'EditTable';
EditTable.useEditTable = function () {
    let store = new TableStore(hookExtensions);
    return store.getAllHooks();
};

export default EditTable;
